import { IBlogArticleImageFields } from 'global';
import Image from 'modules/content-cms/sections/components/image';
import Link from 'next/link';

const BlogImage: React.FC<IBlogArticleImageFields> = (props) => {
  const { title, image, showTitle, link, linkTarget, mobileImage } = props;

  const responsiveImage = (
    <>
      {mobileImage && (
        <div className="sm:hidden">
          <Image {...mobileImage} />
        </div>
      )}
      <div className={mobileImage && 'hidden sm:block'}>
        <Image {...image} />
      </div>
    </>
  );

  if (link)
    return (
      <Link href={link}>
        <a target={linkTarget} className="flex flex-col place-content-center">
          {responsiveImage}
          {showTitle && (
            <h4 className="my-2 text-center text-primary-main">{title}</h4>
          )}
        </a>
      </Link>
    );

  return (
    <div className="flex flex-col place-content-center">
      {responsiveImage}
      {showTitle && <h4 className="my-2 text-center">{title}</h4>}
    </div>
  );
};

export default BlogImage;
